import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <p className="copyright">© 2025 Lorevial. All rights reserved.</p>
        <button className="privacy-button" onClick={() => window.location.href = "/PrivacyPolicy"}>
          Privacy Policy
        </button>
      </div>
    </footer>
  );
};

export default Footer;
